<template>
  <tile class="opc-zmone">
    <foldable v-if="showFoldable" v-model="isExpanded" :title="title" :arrow="showFoldableArrow" :edit="canExpand" :isRemoveWrapAriaLabelledby="true">
      <div slot="head">
        <zm-alert v-if="alertTitle" class="opc-common-info-alert" :title="alertTitle" type="warning" :closable="false"
          show-icon />
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img
              :class="['opc-zm-base-card__logo']"
              :src="isEducationMeeting?logoEdu:logo"
              :alt="title"
            />
          </div>
          <div :class="[
            'opc-zm-base-card__head-right',
            ...headClassForSchool,
          ]">
            <h2 :class="[
              'opc-zm-base-card__name',
              isSchool ? '' : 'text-capitalize',
            ]">
              {{ title }}
              <i class="zm-icon-success main-icon" aria-hidden="true" v-if="!mxIsSimplifyForProEdit"></i>
            </h2>
            <div :class="['opc-zm-base-card__view-detail-button']">
              <template v-if="isExpanded">
                <zm-button data-testid="checkout-button-139" class="opc-zm-base-card__link" type="link" @click="handlePlanDetailsClick" v-if="isEducationMeeting">
                  {{$config('enableEduAnnualUpgrade')? $t('billing.zone.explore_other_plans_edit'): $t('billing.plan_details') }}
                </zm-button>
                <zm-button data-testid="checkout-button-140" class="opc-zmone__link" type="link" @click="handleExploreOtherPlansClick" v-else>
                  {{ $t('billing.zone.explore_other_plans_edit') }}
                </zm-button>
              </template>
            </div>
            <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
              {{ getCollapseText() }}
            </div>
          </div>
        </div>
      </div>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item>
            <p class="opc-zmone__form-label">
              {{ mxIsSimplifyForProEdit ? $t('billing.simplify.select_license') : $t('billing.zone.select_license') }}
              <zm-tooltip class="item" aria-label="Learn more about Select the number of users" placement="top">
                <span class="opc-zone__tip" slot="content" v-html="$t('billing.zone.attendee_info_edit')"></span>
                <i class="zm-icon-info-outline main-icon"
                  @click="handleSelectNumOfUsersTipsClick"></i>
              </zm-tooltip>
              <bought-license v-if="mxIsSimplifyForProEdit" :type="planTypes.ZOOM_MEETING" />
            </p>
            <div class="opc-zmone__quantity-selector-container">
              <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="large"
                controls-position="both" :min="minHost" :max="maxHost" @change="submitForm"
                :label="`${title} Select the number of users`" :decrease-tips="popUpDecreaseTips" :increase-tips="increaseTips"/>
              <user-changes v-if="mxIsSimplifyForProEdit" :type="planTypes.ZOOM_MEETING" :value="form.selectedNumber" />
            </div>
            <div class="opc-plan__bought-license" v-if="!mxIsSimplifyForProEdit">
              <div v-if="showUnlockBizCountTip">{{$t('billing.zoom_one_biz.unlock_license_limit')}}</div>
              <bought-license v-else :type="planTypes.ZOOM_MEETING"/>
            </div>
            <zm-alert class="reason-tips" v-if="licenseTips" type="info" :closable="false">
              <i class="zm-icon-info" style="color: #9191A4;"></i>
              <p @click='onLicenseTipsClick' v-html="licenseTips"></p>
            </zm-alert>
          </zm-form-item>
          <zm-form-item :class="[...classForSimplifySubscriptionCycle]">
            <template slot="label">
              {{ mxIsSimplifyForProEdit ? $t('billing.simplify.subscription_cycle') : $t('billing.select_billing_cycle') }}
              <div v-if="mxIsSimplifyForProEdit" class="opc-plan__billing-text">
                {{ getCurrentBilledText() }}
              </div>
            </template>
            <zm-radio-group
              v-model="form.billingCycle"
              :class="['opc-card-radio']"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-radio data-testid="checkout-radio-141" v-for="plan in currentFilterPlans" :key="plan.billing_cycle" :label="plan.billing_cycle"
                :disabled="billingCycleDisabled(plan)" class="opc-zmone__radio" :class="[!mxIsSimplifyForProEdit ? 'compact' : '']">
                <p class="opc-zmone__radio-title text-capitalize">
                  <span>{{ getBillingCycleText(plan.billing_cycle) }}</span>
                  <CycleCurrentBadge :value="plan" v-if="!showAnnualTermMonthly || mxIsSimplifyForProEdit"/>
                  <save-count
                    v-if="showSaveCount(plan)"
                    :disabled="billingCycleDisabled(plan)"
                    :annual-price="annuallyPrice"
                    :monthly-price="monthlyPrice"
                    :class="[mxIsSimplifyForProEdit ? 'light' : '']"
                  />
                </p>
                <subscription-cycle-sub-title :billingCycle="plan.billing_cycle" :currentCategory="form.category" v-if="showAnnualTermMonthly"/>
                <p v-if="isSchool" class="opc-campus-price-container">
                  <span class="opc-campus-price-container__bill">{{ $money(plan.amount, { forceDiff: true }) }}</span>
                  {{ $t(`billing.common.per_billing_cycle_user.${plan.billing_cycle}`) }}<priceVATTip />
                </p>
                <template v-else>
                <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)" v-if="!mxIsSimplifyForProEdit">
                    <span v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
                          :key="index"
                          :class="[`opc-product-price-container__${key}`, useSmallSize(value) ? 'opc-product-price-container__small' : '']"
                          :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                          aria-hidden="true"
                          >
                      {{ value.symbol ? value.symbol: value }}
                    </span>
                </p>
                <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                  <span v-html="getBilledText(plan)"></span><priceVATTip /><span v-if="showAnnualTermMonthly">*</span>
                </p>
                </template>
                <CycleCurrentBadge :value="plan" v-if="showAnnualTermMonthly && !mxIsSimplifyForProEdit" standalone />
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
          <PriceBillTextTips v-if="showAnnualTermMonthly" />
          <zm-alert class="reason-tips"
            v-if="form.billingCycle !== cycleDisabledKeyAndReason.key && cycleDisabledKeyAndReason.reason" type="info"
            :closable="false">
            <i class="zm-icon-info" style="color: #9191A4;"></i>
            <p @click="onCycleClick" v-html="cycleDisabledKeyAndReason.reason"></p>
          </zm-alert>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import SaveCount from '@/components/save-count.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import UserChanges from '@/components/users-change.vue';
import PriceBillTextTips from '@/plans/ZOOM_MEETING/components/price-bill-text-tips.vue';
import logo from '@/assets/plans/icon_ZM.svg';
import logoEdu from '@/assets/plans/video_sdk.svg'
import {
  A_LINK_TAG_NAME,
  A_LINK_TEXT_CONTENT,
  BILLING_CYCLE, EDIT_FLOW_TRACKING_TYPE,
  limitBillingCycleWithBaseZoneTypes,
  planTypes,
  BASE_PLAN_SUB_TYPES,
  ZOOM_MEETING_PRO_MIN_LICENSE, BillingCycleEnum, AUDIO_SUB_TYPES,
  unlockBizLicenseCount,
  URL_PAGE_TYPE_KEY,
  DEFAULT_MAX_HOST,
} from '@/common/constants';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import _, { debounce, get, groupBy, throttle, orderBy } from 'lodash';
import { getMeetingPlanByCategory, getCategoryNameI18nKey } from '@/plans/ZOOM_MEETING/common/utils';
import plansMixin from '@/plans/mx/plan';
import simplifyForProMixin from '@/plans/ZOOM_MEETING/mixin/simplify-for-pro.js';
import { isEmptyVal, updateHrefWithQueryParams } from '@/utils';
import { ZOOM_MEETING_SUB_TYPES, isInUnlockBizCountRetentionFlow } from '../common/utils';
import saveMixins from '../save-mixins';
import { getPlanUnitWithCycle } from '@/common/product-unit';
import { validDownSellLicense } from '@/utils/validate-downsell';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { editBasePlanWithPartnerMixin } from "@/views/config/partner-refer/mixin/edit-plan-with-partner";
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import ZoomMeetingDialogUtils from '../dialog/utils';
import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';
import { translateToEn } from '@/plugins/i18n'
import promoModifyMixin from '@/common/mixin/promo-modify-mixin';
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';
import { $info } from '@/components/service/config-banner';
import { enableProAnnualMonthlyPaymentPlanP2, enableProAnnualWithMonthlyPaymentPre } from '@/common/constants';
import SubscriptionCycleSubTitle from '@/plans/ZOOM_MEETING/components/subscription-cycle-sub-title.vue';
import { getCollapseText } from '@/plans/ZOOM_MEETING/common/utils';
import { proAnnualMonthlyMarketingCampaignLimited, BILLING_CYCLE_PRIORITY } from '@/utils/annual-term-monthly-utils';

export default {
  name: 'ZoomMeetingEdit',
  mixins: [
    plansMixin,
    saveMixins,
    audioUsCaMixin,
    editBasePlanWithPartnerMixin,
    discountedMonthPrice,
    promoModifyMixin,
    simplifyForProMixin,
  ],
  data() {
    return {
      logo,
      logoEdu,
      isExpanded: true,
      form: {
        category: 'pro',
        billingCycle: 'annual',
        selectedNumber: 1,
      },
      oldPlanCode: '',
      BILLING_CYCLE: BILLING_CYCLE,
      isInitUpdateForm: false,
      canExpand: true,
      showFoldable: true,
      planTypes,
      alertTitle: ''
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      boughtPlans: state => state.ShoppingCart.boughtPlans,
      assignInfo: state => state.ShoppingCart.assignInfo,
      updateBasePlan: state => state.Product.updateBasePlan,
    }),
    ...mapGetters([
      'getSelectedPlans',
      'getUserCurrentSubscriptions',
      'basicConfig',
      'disableMonthly2AnnualTip',
      'isMultipleCoupon',
      'getCurrentBasePlanInfo',
      'plansofBizBundle',
      'limitLicenseWithBaseZoneTypes',
      'partnerRefer',
      'migratePlanState',
      'boughtPlansGroupByCategoryCode',
      'boughtPlans',
      'freeTrialPlans',
      'getBoughtBasePlanInfo',
      'assignInfo',
      'currentEditPlan',
    ]),
    boughtBaseCategory() {
      const { plans = [] } = this.getBoughtBasePlanInfo;
      return get(plans, '0.zoomMeetingCategory', '');
    },
    showFoldableArrow() {
      return this.canExpand && !this.mxIsSimplifyForProEdit;
    },
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentPlansHasAnnualTermMonthly() {
      return this.currentPlans.some((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY);
    },
    showAnnualTermMonthly() {
      return (
        (enableProAnnualWithMonthlyPaymentPre ||
          enableProAnnualMonthlyPaymentPlanP2) &&
        this.currentPlansHasAnnualTermMonthly &&
        !this.hideAnnualTermMonthlyForCurrentEditPlan
      );
    },
    hideAnnualTermMonthlyForCurrentEditPlan() {
      // * hide pro annual term monthly for biz and standard pro annual(yearly_c50) plan
      return proAnnualMonthlyMarketingCampaignLimited() ||
        (!enableProAnnualMonthlyPaymentPlanP2 && this.currentEditPlanIsBiz) ||
        (!enableProAnnualMonthlyPaymentPlanP2 && this.currentEditPlanIsStandardProAnnual);
    },
    currentEditPlanIsStandardProAnnual() {
      const standardProAnnualPlancode = 'yearly_c50';
      return this.currentEditPlan?.plan_code === standardProAnnualPlancode && this.getSelectedPlans[0]?.plan_code === standardProAnnualPlancode;
    },
    currentEditPlanIsBiz() {
      return this.currentEditPlan?.category === BASE_PLAN_SUB_TYPES.BIZ;
    },
    currentFilterPlans() {
      let currentPlans = this.currentPlans;
      if (!this.showAnnualTermMonthly && this.currentPlansHasAnnualTermMonthly) {
        return currentPlans.filter((item) => item.billing_cycle !== BILLING_CYCLE.ANNUAL_TERM_MONTHLY);
      }
      // Only sort plans by billing cycle priority when annual term monthly payment is enabled, available, and not in simplified pro edit mode
      if (this.showAnnualTermMonthly && !this.mxIsSimplifyForProEdit) {
        currentPlans = orderBy(
          currentPlans,
          [
            plan => BILLING_CYCLE_PRIORITY[plan.billing_cycle] || 99
          ],
        );
      }
      return currentPlans;
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    isEducationMeeting() {
      return this.form.category === BASE_PLAN_SUB_TYPES.EDUCATION
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    monthlyPrice() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount : 0;
    },
    annuallyPrice() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      return annualPlan ? annualPlan.amount : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    totalCoast() {
      if (this.formPlan) {
        return this.formPlan.amount * this.form.selectedNumber;
      }
      return 0;
    },
    limitCycleAddonPlans() {
      const disableCycle = this.currentPlans.find((p) => p.cycleValue < this.boughtMeetingPlan.cycleValue)?.cycleValue;
      if (!disableCycle) {
        return [];
      }

      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.cycleValue > disableCycle
      ));
    },
    maxLicenseAddon() {
      return this.getUserCurrentSubscriptions
        .filter(item => _.includes(this.limitLicenseWithBaseZoneTypes, item.type))
        .reduce((maxPlan, plan) => {
          if (plan.cartInfo.selected_number > get(maxPlan, 'cartInfo.selected_number', 0)) {
            return plan;
          }
          return maxPlan;
        }, {});
    },
    attendee() {
      return get(this.currentPlans, "[0].participants", 0);
    },
    trackingPlanName() {
       if (this.isEducationMeeting) {
        return this.$t(this.formPlan?.planNameKey);
      }
      else if (this.isSchool) {
        return translateToEn(this.formPlan?.planNameKey);
      }
      else {
        return this.$t(`Zoom One ${this.form?.category}`);
      }
    },
    hasAccountDiscount() {
      return get(this.basicConfig, 'hasAccountDiscount', false);
    },
    boughtMeetingPlan() {
      return this.boughtPlans.find(item => item.type === planTypes.ZOOM_MEETING);
    },
    boughtLicense(){
      return get(this.boughtMeetingPlan, 'cartInfo.selected_number', 1);
    },
    bizHasNotStandardPriceUnlimitedAudioPlan() {
      return this.form.category === BASE_PLAN_SUB_TYPES.BIZ
        && this.boughtPlans.some(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED && item.isStandardPrice === false);
    },
    isStandardPrice() {
      if (this.hasAccountDiscount) {
        return true;
      }
      return this.boughtMeetingPlan.isStandardPrice && !this.bizHasNotStandardPriceUnlimitedAudioPlan;
    },
    zmUnitedPlanQuantity() {
      return this.boughtPlans
        .filter(item => item.type === planTypes.ZOOM_UNITED)
        .reduce((pre, item) => item.cartInfo.selected_number + pre, 0);
    },
    zoneBundlePlanQuantity() {
      return this.boughtPlans
        .filter(item => item.type === planTypes.ZOOM_ONE_BUNDLE)
        .reduce((pre, item) => item.cartInfo.selected_number + pre, 0);
    },
    boughtMeetingLicense() {
      return get(this.boughtMeetingPlan, 'cartInfo.selected_number', 1);
    },
    minHostAndReason() {
      const boughtLicense = this.boughtMeetingLicense;
      if (this.basicConfig.downSellData && this.basicConfig.downSellData.disableDownSell) {
        const reason = this.$t('billing.error.can_not_bought_plan_tips');
        // MRR >= 500 (direct account)
        return {
          minHost: boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO,
        };
      } else if (!this.isStandardPrice) {
        const reason = this.$t('billing.planform.meeting_license_custom_pricing');

        // customized price
        return {
          minHost: this.isEducationMeeting ?
            Math.max(boughtLicense, this.boughtMeetingPlan.min) :
            boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.HAS_CUSTOMER_PRICING,
        }
      } else if (this.eligibleInfoForPromoCase?.min) { // promote campaign link (partner/marketing coupon)
        const reason = this.getDownsellDisabledReasonForPromotion({
          reason: this.eligibleInfoForPromoCase?.reason,
          boughtLicense,
        });
        return {
          minHost: boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO,
        }
      }

      const meetingMin = get(this.formPlan, 'min', 1);
      const bundleLicense = this.zmUnitedPlanQuantity + this.zoneBundlePlanQuantity;
      let minHost = Math.max(meetingMin - bundleLicense, 1);

      const maxLicenseAddonLicense = get(this.maxLicenseAddon, 'cartInfo.selected_number', 0);

      if (this.maxLicenseAddon && minHost < maxLicenseAddonLicense - bundleLicense) {
        const maxLicenseAddonTypeNameKey = this.maxLicenseAddon.typeNameKey;
        const maxLicenseAddonTypeName = this.$t(maxLicenseAddonTypeNameKey);
        return {
          minHost: (maxLicenseAddonLicense - bundleLicense) > boughtLicense ? boughtLicense : (maxLicenseAddonLicense - bundleLicense),
          reason: this.$t('billing.meeting_license_decrease_tips_need_decrease_addon', { product: maxLicenseAddonTypeName }),
          popUpReason: this.$t('billing.licences_limit_tips', [maxLicenseAddonTypeName, this.$t('billing.planform.title.zoom_meeting_zoomonenew')]),
          trackingType: EDIT_FLOW_TRACKING_TYPE.KEEP_ADDON,
        }
      }
      // if edit biz and no biz plus plan, minHost >= ZOOM_MEETING_PRO_MIN_LICENSE
      const { plans } = this.getCurrentBasePlanInfo;
      if (plans?.[0]?.category === BASE_PLAN_SUB_TYPES.BIZ) {
        const { bundleLicenses } = this.plansofBizBundle;
        // only show when bundleLicenses > 0, which means user has been purchased biz+
        // if the current currency is not support biz+, we don't need to show this banner
        if (bundleLicenses > 0) {
          minHost = unlockBizLicenseCount ? 1 : Math.max(ZOOM_MEETING_PRO_MIN_LICENSE - this.zmUnitedPlanQuantity - bundleLicenses, 1);
          const reason = this.form.selectedNumber > 1 ? this.$t('billing.zobizplus.required_license_warning', [ZOOM_MEETING_PRO_MIN_LICENSE]) : '';
          return {
            minHost,
            reason,
            popUpReason: reason,
          }
        }
        // check biz plan
        const quantity = getMeetingPlanByCategory(this.boughtPlans)?.cartInfo?.selected_number ?? ZOOM_MEETING_PRO_MIN_LICENSE;
        minHost = quantity > ZOOM_MEETING_PRO_MIN_LICENSE ? ZOOM_MEETING_PRO_MIN_LICENSE : quantity;
      }
      // pro2biz
      if (this.migratePlanState.is.pro2biz) {
        minHost = Math.max(this.boughtMeetingPlan.cartInfo.selected_number, ZOOM_MEETING_PRO_MIN_LICENSE);
      }

      return {
        minHost: minHost,
        reason: '',
        popUpReason: '',
      };
    },
    minHost() {
      return this.minHostAndReason.minHost;
    },
    minHostReason() {
      return this.minHostAndReason.reason;
    },
    minHostPopUpReason() {
      return this.minHostAndReason.popUpReason;
    },
    cycleDisabledKeyAndReason() {
      const currentBillingCycles = this.currentFilterPlans.map(p => p.billing_cycle);

      const { isBulkLicenseAccount } = this.basicConfig;
      if (isBulkLicenseAccount) {
        return {
          key: this.form.billingCycle === BILLING_CYCLE.MONTHLY ? BILLING_CYCLE.ANNUAL : BILLING_CYCLE.MONTHLY,
          keys: currentBillingCycles.filter(billingCycle => billingCycle !== this.form.billingCycle),
          reason: this.$t('billing.error.buld_acount_license'),
        };
      }

      if (this.disableMonthly2AnnualTip && !this.isMultipleCoupon) {
        return {
          key: BILLING_CYCLE.ANNUAL,
          keys: currentBillingCycles.filter(billingCycle => billingCycle !== this.form.billingCycle),
          reason: this.disableMonthly2AnnualTip,
        }
      }

      if (this.cycleDisabledKeyAndReasonForPartner) {
        return this.cycleDisabledKeyAndReasonForPartner;
      }

      if (this.eligibleInfoForPromoCase?.key) {
        return this.eligibleInfoForPromoCase;
      }

      const planGroupByType = groupBy(this.limitCycleAddonPlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (this.limitCycleAddonPlans.length) {
        const disablePlan = this.currentPlans.find((p) => p.cycleValue < this.boughtMeetingPlan.cycleValue);
        return {
          key: disablePlan.billing_cycle,
          reason: this.$t('billing.planform.can_not_select_with_special_addon', [
            this.$t('billing.planform.title.zoom_meeting_zoomonenew'),
            typeNames.join(','),
            this.$t(`billing.billing_cycle.${disablePlan.billing_cycle}`)?.toLowerCase(),
          ]),
        };
      }
      return {};
    },
    canSwitchCategory() {
      const hasBundle = !!(this.zmUnitedPlanQuantity + this.zoneBundlePlanQuantity);
      return !hasBundle;
    },
    assignedMeetingInfo() {
      const boughtMeetingCode = get(this.boughtMeetingPlan, 'plan_code', '');
      return this.assignInfo[boughtMeetingCode];
    },
    needUnAssignTips() {
      return validDownSellLicense({ quantity: this.form.selectedNumber })?.errorMessage;
    },
    mx_decreaseTips() {
      if (this.needUnAssignTips) {
        return this.needUnAssignTips;
      }
      if (this.form.selectedNumber <= this.minHost) {

        if (this.$context.is.mixBuy) {
          return this.minHostPopUpReason;
        }

        return this.minHostReason;
      }
      return '';
    },
    popUpDecreaseTips() {
      if (this.$context.is.mixBuy) return this.mx_decreaseTips;
      return "";
    },
    licenseTips() {
      if (this.$context.is.mixBuy) return "";
      return this.mx_decreaseTips;
    },
    cartMeetingPlan() {
      return this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
    },
    cycleDisabledKeyAndReasonForPartner() {
      return this.getCycleDisabledKeyAndReasonForPartner();
    },
    maxHostInfo() {
      if (this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return {
          max: this.boughtLicense + 99,
          tips: this.$t('billing.error.cant_add_100')
        }
      }
      return {
        max: 9999,
        tips: ''
      }
    },
    maxHost() {
      if (!this.canExpand && this.updateBasePlan?.autoAdd) {
        return DEFAULT_MAX_HOST;
      }
      return this.maxHostInfo.max;
    },
    increaseTips() {
      if (this.form.selectedNumber >= this.maxHostInfo.max) {
        return this.maxHostInfo.tips;
      }
      return '';
    },
    isSchool() {
      return this.form?.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
    },
    showUnlockBizCountTip() {
      return isInUnlockBizCountRetentionFlow() && this.minHost < 10
    },
    headClassForSchool() {
      if (this.isSchool) {
        return this.isExpanded ? ['opc-zm-base-card__head-right__for_school--expand'] : ['opc-zm-base-card__head-right__for_school--collapse'];
      }
      return [];
    },
    classForSimplifySubscriptionCycle() {
      return this.mxIsSimplifyForProEdit ? [...this.mxClassForSimplify, 'zm-form-item__opc-simplify'] : [];
    }
  },
  created() {
    this.updateForm(true);
    ZoomMeetingDialogUtils.install(this.formPlan);
  },
  mounted() {
    this.$context.$on('collapse-plan-card', this.collapseCard);
    if(this.isEducationMeeting && this.$config('enableEduAnnualUpgrade')){
      const link = '/opc/buy/config?plan=zoneduschcmp&period=annual&from=zoneduschcmp&type=edu2esc';
      $info({ message: this.$t('billing.zone.edu.alert_title', [updateHrefWithQueryParams(link, [URL_PAGE_TYPE_KEY])]) ,className:'reason-tips'});
    }
  },
  methods: {
    getCollapseText() {
      return getCollapseText(
        this.formPlan?.amount,
        this.form.billingCycle,
        this.form.selectedNumber,
        this.formPlan?.cycleValue
      );
    },
    showSaveCount(plan) {
      return this.mxIsSimplifyForProEdit &&
        plan.billing_cycle === BILLING_CYCLE.ANNUAL &&
        this.currentEditPlan?.billing_cycle !== BILLING_CYCLE.ANNUAL;
    },
    getBilledText(plan) {
      return this.mxIsSimplifyForProEdit ?
        this.ariaPriceOfMonthForLabel(plan) + this.getMergedBilledText(plan.billing_cycle, plan.amount) :
        this.getMergedBilledText(plan.billing_cycle, plan.amount)
    },
    getBillingCycleText(billingCycle) {
      let text = this.$t(`billing.billing_cycle.${billingCycle}`);
      if (this.mxIsSimplifyForProEdit && billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        text = `${text}, ${this.$t('billing.bill_monthly')}`;
      }
      return text;
    },
    getCurrentBilledText() {
      const bounghtBillingCycle = this.boughtMeetingPlan.billing_cycle;
      if (bounghtBillingCycle === BILLING_CYCLE.MONTHLY) {
        return this.$t('billing.simplify.current_billed_monthly');
      } else if (bounghtBillingCycle === BILLING_CYCLE.ANNUAL) {
        return this.$t('billing.simplify.current_billed_annually');
      } else {
        return ''
      }
    },
    BillingCycleEnum() {
      return BillingCycleEnum
    },
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan', 'savePersist', 'setUpdateBasePlan']),
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      // pre check from params
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
        this.oldPlanCode = shoppingCartPlan.plan_code;
        this.mxCheckCollapseSimplifyView(this.form);
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    async handleExploreOtherPlansClick() {
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
      this.$context.$emit('change-tile-status', false);
      await this.showFullComparisonDialog();
    },
    async handlePlanDetailsClick() {
      if (this.isEducationMeeting) {
        this.$tracking.buyInteraction('plan details selected', this.trackingPlanName);
        if(this.$config('enableEduAnnualUpgrade')) return await this.showFullComparisonDialog();
      }
      await ZoomMeetingDialogUtils.showPlanDetail({ planCategory: this.formPlan.category });
    },
    handleSelectNumOfUsersTipsClick() {
      if (this.isEducationMeeting) {
        this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'number of licenses - tooltip');
      } else {
        this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'number of users - tooltip')
      }
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', 'full plan comparison - impression');
      await ZoomMeetingDialogUtils.showComparisonDialog({
        planCategory: this.formPlan.category,
        largeMeetingConfig: {
          school: {
            callback: () => {},
            disabled: true,
            display: false
          },
          schoolPlus: {
            callback: () => {},
            disabled: true,
            display: false
          },
        }
      });
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    updateCollapsedPlan(from) {
      this.updateForm();
      this.alertTitle = this.$t('billing.zone.alert_title', [from, this.$t(this.boughtMeetingPlan?.planNameKey)])
      this.canExpand = false;
      this.isExpanded = false;
      this.setUpdateBasePlan({ ...this.updateBasePlan, update: false, from: '' });
      this.showFoldable = false;
      this.$nextTick(() => {
        this.showFoldable = true; // Avoid the appearance of the collapse animation.
      })
    },
    onLicenseTipsClick(event) {
      if (this.isSchool && event.target.tagName?.toUpperCase() === 'A') {
        this.$tracking.buyInteraction('banner - product level', `${this.trackingPlanName} - ${event.currentTarget.textContent} - ${event.target.textContent}`)
      }

      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.FORM) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - 'you are not able to make this change to  your account mid-contract' - contact form`);
        return;
      }
      this.doReturnPlanManagementTracking(event, 'adjust the add-on product and base product license quantity');
    },
    onCycleClick(event) {
      this.doReturnPlanManagementTracking(event, 'update to monthly subscription first');
    },
    doReturnPlanManagementTracking(event, msg) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.RETURN_PLAN_MANAGEMENT) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - ${msg} - return to plan management`);
      }
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
    billingCycleDisabled({ billing_cycle, disabled }) {
      if (Array.isArray(this.cycleDisabledKeyAndReason.keys)) {
        return this.cycleDisabledKeyAndReason.keys.includes(billing_cycle) || disabled;
      }
      return this.cycleDisabledKeyAndReason.key === billing_cycle || disabled;
    },
    collapseCard() {
      this.isExpanded = false;
    }
  },
  components: {
    Foldable,
    Tile,
    InputNumberWithPopover,
    PreviewPayment,
    BoughtLicense,
    CycleCurrentBadge,
    SaveCount,
    UserChanges,
    SubscriptionCycleSubTitle,
    PriceBillTextTips,
  },
  watch: {
    'eligibleInfoForPromoCase.min': {
      immediate: true,
      handler(val) {
        if (val && this.form.selectedNumber < this.boughtMeetingLicense) {
          this.submitForm();
        }
      }
    },
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    'form.billingCycle': {
      immediate: true,
      handler: debounce(function (val) {
        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
        if (val !== this.cycleDisabledKeyAndReason.key && this.cycleDisabledKeyAndReason.reason) {
          this.$tracking.buyInteraction(
            'banner - product level',
            `${this.trackingPlanName} - update to monthly subscription first - impression`);
        }

        if (this.isSchool) {
          this.$tracking.buyInteraction('subscription cycle', `${this.trackingPlanName} - ${val}`)
        }
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        let _newLicense = newLicense;
        if (this.$context.is.delta) _newLicense = this.deltaForm?.selectedNumber;
        if (this.formPlan && !this.isInitUpdateForm) {
          // event tracking
          if (this.isEducationMeeting) {
            this.$tracking.buyInteraction('number of licenses', `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${_newLicense}`);
          } else {
            this.$tracking.buyInteraction(this.isSchool ? 'number of users' : 'number of hosts', `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${_newLicense}`);
          }
        }
      }, 500),
    },
    updateBasePlan: {
      handler(val) {
        val?.update && this.updateCollapsedPlan(val?.from);
      },
    },
    licenseTips: {
      handler(val) {
        if (val) {
          if (this.isSchool) {
            this.$tracking.buyInteraction(`banner - product level`, `${this.trackingPlanName} - ${val.replace(/(<([^>]+)>)/ig, '')} - impression`)
          }

          if (this.form.selectedNumber <= this.minHost) {
            if (this.minHostAndReason?.trackingType) {
              switch (this.minHostAndReason.trackingType) {
                case EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - you are not able to make this change to  your account mid-contract - impression`);
                  break;
                case EDIT_FLOW_TRACKING_TYPE.HAS_CUSTOMER_PRICING:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - your account has custom pricing - impression`);
                  break;
                case EDIT_FLOW_TRACKING_TYPE.KEEP_ADDON:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - adjust the add-on product and base product license quantity - impression`);
              }
            }
          }
        }
      },
    },
    cartMeetingPlan: {
      deep: true,
      handler() {
        this.updateForm();
      },
    },
    maxHost(val) {
      if (this.form.selectedNumber > val) {
        this.form.selectedNumber = val
        this.submitForm(val)
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-zmone {
  .main-icon {
    color: $theme-color;
  }

  .reason-tips {
    margin-top: 12px;

    .zm-alert__description {
      display: flex;
      align-items: center;
    }

    p {
      margin-left: 13px;
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #515079;
    }
  }

  &__link.zm-button--link {
    margin-left: 5px;
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 12px;
    @include media(mobile) {
      margin-top: 12px;
    }
    @include simplifyStyle() {
      margin: 0;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #00053d;
  }

  &__main {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #dfdfe4;
    @include simplifyStyle() {
      margin-top: 20px;
      padding-top: 20px;
      .opc-config-form {
        padding: 0;
        .zm-form-item {
          margin-bottom: 0;
          .zm-form-item__content {
            display: flex;
            margin-bottom: 20px;
            flex-wrap: wrap;
            .opc-zmone__form-label,
            .opc-zmone__quantity-selector-container {
              flex: 1;
              margin: 0;
            }
            .reason-tips {
              flex-basis: 100%;
            }
            .opc-zmone__form-label {
              font-size: 16px;
              font-weight: 600;
              line-height: 150%;
            }
          }
          &.zm-form-item__opc-simplify {
            border-top: 1px solid #dfdfe4;
            padding-top: 20px;
            margin-bottom: 0;
            display: flex;
            .zm-form-item__header,
            .zm-form-item__content {
              flex: 1;
              margin: 0;
            }
          }
        }
        .opc-card-radio {
          flex-direction: column;
          margin: 0;
          gap: 8px;
          .zm-radio {
            &__inner {
              display: block;
            }
            &__label {
              &.is-checked::after {
                display: none;
              }
              &--inner {
                height: auto;
                padding: 0;
                border: none;
                min-width: auto;
              }
              &.is-checked {
                .zm-radio__label--inner {
                  border: none;
                }
              }
              &.is-focus {
                .zm-radio__label--inner {
                  .is-keyboard-event & {
                      box-shadow: none;
                  }
                }
              }
              &:not(.is-disabled) {
                &:hover {
                  .zm-radio__label--inner {
                      background: none;
                  }
                }
              }
            }
          }
          .opc-zmone__radio {
            &-title {
              color: #2A2B2D;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
              margin-bottom: 4px;
            }
          }
        }
      }
    }

    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
    padding: 0;
    margin: 0;

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: #FEF7D9;
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: #00031F;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      width: 100%;

      .zm-radio__wrap {
        width: 100%;
      }
    }
  }

  .opc-card-radio &__radio {
    &.compact {
      .zm-radio__label--inner {
        padding: 12px;
      }
    }
    .zm-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    .zm-radio__label {
      &.is-disabled {
        .opc-zmone__radio-title,
        .opc-zmone__radio-price,
        .opc-zmone__radio-price-unit,
        .opc-zmone__radio-title-billed-text {
          color: #9191A4 !important;
        }
      }
    }

    &-title {
      color: #00053D;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      margin: 0;
      display: flex;
      flex-wrap: wrap;

      align-items: center;

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: #4a7d5c;
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: #00053D;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;

      &-unit {
        color: #666487;
        font-size: 12px;
        font-style: normal;
        font-weight: 450;
        line-height: 120%;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: #515079;
      }
    }
  }
  .opc-plan__bought-license {
    font-family: Almaden Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: left;
    color: #666487;
  }

}

.opc-zm-base-card__view-detail-button {
  @include simplifyStyle() {
    flex-shrink: 0;
    .zm-button.zm-button--link {
      color: #0D6BDE;
      font-weight: 500 !important;
    }
  }
}

.opc-plan__billing-text {
  color: #666487;
  font-family: "Almaden Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
</style>

<style lang="scss">
.opc-zone__tip b {
  font-weight: bold !important;
}
</style>
